<template>
  <div class="SidebarSide" :class="{ open: isOpen }">
    <MainLogo
      format="png"
      :size="isOpen ? null : 'square'"
      :type="isOpen ? 'white' : null" />
    <nav>
      <template v-for="(link, index) in links">
        <MenuLink
          :key="index"
          :index="index"
          :link="link"
          @click="$emit('update:activeIndex', index)" />
        <transition-group :key="`${index}_transition`" appear name="slide-down">
          <div
            v-if="activeIndex === index && link.children && link.children.length"
            :key="`${index}_children`"
            class="children">
            <MenuLink
              v-for="(child, childIndex) in link.children"
              :key="`${index}_${childIndex}`"
              :index="childIndex"
              :link="child" />
          </div>
        </transition-group>
      </template>
    </nav>
    <div class="bottom">
      <Route data-cy="logout" to="Logout">
        <Icon name="lock" />
        {{ isOpen ? 'Logout' : '' }}
      </Route>
      <div
        class="collapse"
        @click="toggle"
        @keydown.enter="toggle">
        <Icon :name="isOpen ? 'left' : 'right'" />
        {{ isOpen ? 'Collapse' : '' }}
      </div>
    </div>
  </div>
</template>

<script>
import MainLogo from './MainLogo'
import MenuLink from './MenuLink'
import { getters } from '../../utils'

export default {
  components: {
    MainLogo,
    MenuLink,
  },
  props: {
    isOpen: Boolean,
    links: { type: Array, default: () => ([]) },
    activeIndex: { type: Number, required: false },
  },
  computed: {
    ...getters('isDesktop'),
  },
  methods: {
    toggle() {
      this.$emit('update:isOpen', !this.isOpen)
    },
  },
}
</script>

<style lang="scss">
.SidebarSide {
  @include trans(0.2s);
  color: $white;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  @include sm {
    width: $sidebar-width;
  }

  > .MainLogo {
    display: block;
    height: 3rem;
    margin: 1rem 0;
    text-align: center;
  }

  > nav {
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 3rem;
    width: 100%;

    .MenuLink {
      border-right: none;
      padding: unset;
      position: relative;
      z-index: 1;

      a {
        align-items: center;
        border-bottom: 0;
        color: inherit;
        display: flex;
        font-weight: $semibold;
        height: 3.5rem;
        line-height: $lh * 1.125;
        opacity: 0.8;
        padding: 0 1rem 0 1.5rem;
        position: relative;
        text-align: left;
        white-space: nowrap;
        width: 100%;

        &::after {
          @include trans;
          background: transparent;
          bottom: 0;
          content: ' ';
          display: block;
          height: 1px;
          position: absolute;
          right: 0;
          width: 1px;
        }

        > span {
          @include trans;

          &.Icon {
            float: left;
            font-size: $h3;
            line-height: $lh;
          }

          &.label {
            display: inline-block;
            padding-left: 1.5rem;
          }
        }

        &:hover, &:focus {
          opacity: 1;
        }

        &.router-link-active {
          opacity: 1;

          &::after {
            background: $white;
            border-radius: $radius 0 0 $radius;
            height: 100%;
            left: auto;
            top: 0;
            width: 4px;
          }
        }
      }
    }

    .children {
      position: relative;

      .MenuLink {
        width: 100%;

        > a {
          padding-left: calc(1.5rem - 3px);
        }
      }
    }
  }

  > .bottom {
    margin-top: auto;
    text-align: center;
    white-space: nowrap;
    width: 100%;

    > a {
      @include trans;
      border: 0;
      color: $white;
      display: block;
      padding: 1rem;

      &:hover {
        background: $grey-lightest;
        color: $text-color-mid;
      }
    }

    > .collapse {
      cursor: pointer;
      padding: 1rem;

      &:hover {
        background: $grey-lightest;
        color: $text-color-mid;
      }
    }
  }

  &:not(.open) {
    width: $sidebar-width-compact;

    > nav {
      .MenuLink {
        a {
          text-align: center;

          > span {
            &.Icon {
              float: none;
            }

            &.label {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
